import {EstimateApi} from '../network/estimate_api';
import {GridLoader} from './grid_loader';

export class EstimateUpdater {
    constructor(private estimateApi: EstimateApi, private gridLoader: GridLoader) {}

    public async update(estimateId: number, state: string) {
        await this.estimateApi.update(estimateId, state);
        await this.gridLoader.invalidate();
    }
}
